import { format, Locale } from "date-fns";

export const getHourMinuteOptions = (
  minuteSubdivision: number = 15,
  locale: Locale | undefined,
) => {
  if (
    60 % minuteSubdivision !== 0 ||
    minuteSubdivision < 1 ||
    minuteSubdivision > 60
  ) {
    throw new Error(
      "Minute subdivision must be a divisor of 60 and less than 60",
    );
  }
  const hours = Array.from({ length: 24 }, (_, i) => i);
  const minutes = Array.from(
    { length: 60 / minuteSubdivision },
    (_, i) => i * minuteSubdivision,
  );
  const now = new Date().toISOString().split("T")[0];

  return hours.flatMap(hour => {
    const hourString = hour.toString().padStart(2, "0");
    return minutes.flatMap(minute => {
      const minuteString = minute.toString().padStart(2, "0");
      return {
        label: format(`${now}T${hourString}:${minuteString}`, "h:mma", {
          locale,
        }).toLowerCase(),
        value: `${hourString}:${minuteString}`,
      };
    });
  });
};
